import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function RedirectOrder() {
  const { orderId } = useParams();

  useEffect(() => {
    const targetUrl = `famigo://order-detail/${orderId}`;
    window.location.href = targetUrl;
  }, []);

  return (
    <div></div>
  );
}

export default RedirectOrder;
